import type { StylesConfig } from 'react-select';

/** react-select theme matching the settings form controls (dark panel, gold focus, monospace). */
export function selectStyles<Option, IsMulti extends boolean>(): StylesConfig<Option, IsMulti> {
  return {
    control: (base, state) => ({
      ...base,
      background: 'var(--bg2)',
      border: `1px solid ${state.isFocused ? 'var(--gold)' : 'var(--bm)'}`,
      borderRadius: 4,
      boxShadow: 'none',
      minHeight: 28,
      cursor: 'text',
      '&:hover': { borderColor: 'var(--gold)' },
    }),
    menu: (base) => ({
      ...base,
      background: '#13161e',
      border: '1px solid #2a2f3d',
      borderRadius: 4,
      boxShadow: '0 4px 16px rgba(0,0,0,.6)',
      zIndex: 9999,
    }),
    menuList: (base) => ({ ...base, background: '#13161e', borderRadius: 4, padding: 0 }),
    option: (base, state) => ({
      ...base,
      background: state.isFocused ? 'rgba(212,175,55,.12)' : 'transparent',
      color: state.isFocused ? 'var(--gold)' : 'var(--t2)',
      fontFamily: 'var(--mono)',
      fontSize: 11,
      padding: '6px 10px',
      cursor: 'pointer',
    }),
    input: (base) => ({ ...base, color: 'var(--t1)', fontFamily: 'var(--mono)', fontSize: 11, margin: 0, padding: 0 }),
    placeholder: (base) => ({ ...base, color: 'var(--t3)', fontFamily: 'var(--mono)', fontSize: 11 }),
    singleValue: (base) => ({ ...base, color: 'var(--t1)', fontFamily: 'var(--mono)', fontSize: 11 }),
    multiValue: (base) => ({ ...base, background: 'rgba(212,175,55,.12)', borderRadius: 3 }),
    multiValueLabel: (base) => ({ ...base, color: 'var(--gold)', fontFamily: 'var(--mono)', fontSize: 11 }),
    multiValueRemove: (base) => ({
      ...base,
      color: 'var(--t3)',
      ':hover': { background: 'rgba(239,68,68,.2)', color: 'var(--red)' },
    }),
    valueContainer: (base) => ({ ...base, padding: '2px 8px' }),
    dropdownIndicator: (base) => ({ ...base, color: 'var(--t3)', padding: '0 6px', '&:hover': { color: 'var(--gold)' } }),
    clearIndicator: (base) => ({ ...base, color: 'var(--t3)', padding: '0 4px', '&:hover': { color: 'var(--red)' } }),
    indicatorSeparator: () => ({ display: 'none' }),
    noOptionsMessage: (base) => ({ ...base, color: 'var(--t3)', fontFamily: 'var(--mono)', fontSize: 11 }),
    loadingMessage: (base) => ({ ...base, color: 'var(--t3)', fontFamily: 'var(--mono)', fontSize: 11 }),
  };
}
